/*
  By Charlot · demande d'amenagement d'espace.

  Le meme script de reception que le Studio Pro, avec type "amenagement" : la demande
  arrive chez Charlotte avec son objet propre, son dossier Drive et son accuse de reception.

  Regles reprises du Studio Pro, elles ont deja servi :
  - le corps part en text/plain, sinon le navigateur demande une autorisation prealable
    que Google Apps Script ne sait pas donner ;
  - deux tentatives, puis un lien mailto pre rempli : une demande ne se perd jamais ;
  - piege a robots invisible et duree minimale sur le formulaire.
*/
(function () {
  "use strict";
  const racine = document.getElementById("amenagement-demande");
  if (!racine) return;
  const $ = s => racine.querySelector(s);
  const bloc = document.getElementById("am-donnees");
  let DON = {};
  try { DON = JSON.parse(bloc.textContent); } catch (e) { DON = {}; }

  const DEBUT = Date.now();
  const MAX_FICHIERS = 6;
  const MAX_OCTETS = 18 * 1024 * 1024;      // le script accepte 25 Mo, on garde de la marge
  const TYPES = /^(image\/(png|jpeg|webp)|application\/pdf)$/;
  let fichiers = [], envoiEnCours = false, identifiant = null;

  const v = id => (($(id) || {}).value || "").trim();
  const nouvelId = () => "am-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);

  // ---------------------------------------------------------------- les fichiers
  const poids = () => fichiers.reduce((s, f) => s + f.size, 0);
  function decrireFichiers() {
    const z = $("#am-liste");
    if (!fichiers.length) { z.textContent = ""; return; }
    const mo = (poids() / 1048576).toFixed(1).replace(".", ",");
    z.textContent = `${fichiers.length} fichier${fichiers.length > 1 ? "s" : ""} joint${fichiers.length > 1 ? "s" : ""} : `
      + fichiers.map(f => f.name).join(", ") + ` (${mo} Mo)`;
  }
  $("#am-fichiers").addEventListener("change", e => {
    const refuses = [];
    for (const f of Array.from(e.target.files || [])) {
      if (fichiers.length >= MAX_FICHIERS) { refuses.push(f.name + " (trop de fichiers)"); continue; }
      if (!TYPES.test(f.type)) { refuses.push(f.name + " (format non pris en charge)"); continue; }
      if (poids() + f.size > MAX_OCTETS) { refuses.push(f.name + " (trop lourd)"); continue; }
      fichiers.push(f);
    }
    e.target.value = "";
    decrireFichiers();
    if (refuses.length) montrerErreur("Certains fichiers n'ont pas pu être joints : " + refuses.join(", ") + ". Vous pourrez nous les envoyer en réponse à notre email.");
    else cacherErreur();
  });

  function enBase64(fichier) {
    return new Promise((ok, ko) => {
      const l = new FileReader();
      l.onload = () => ok(String(l.result).split(",")[1] || "");
      l.onerror = () => ko(new Error("lecture"));
      l.readAsDataURL(fichier);
    });
  }

  // ---------------------------------------------------------------- les messages
  function cacherErreur() { const z = $("#am-erreur"); z.hidden = true; z.textContent = ""; }
  function montrerErreur(texte, avecMail) {
    const z = $("#am-erreur");
    if (avecMail) {
      const corps = encodeURIComponent(
        `Société : ${v("#am-societe")}\nContact : ${v("#am-nom")} ${v("#am-telephone")}\nLieu : ${v("#am-lieu")}\n\n${v("#am-projet")}`);
      z.innerHTML = texte + ` <a href="mailto:business@bycharlot.com?subject=${encodeURIComponent("Aménagement d'espace")}&body=${corps}">Envoyer par email</a>`;
    } else z.textContent = texte;
    z.hidden = false;
  }
  // un message de champ disparait des que le champ est corrige
  racine.querySelectorAll(".am-champ input, .am-champ textarea").forEach(el =>
    el.addEventListener("input", () => { const c = el.closest(".am-champ"); if (c) c.classList.remove("erreur"); }));

  // ---------------------------------------------------------------- l'envoi
  async function poster(corps) {
    let rep = null;
    for (let essai = 0; essai < 2 && !rep; essai++) {
      try {
        const arret = new AbortController(), minuteur = setTimeout(() => arret.abort(), 60000);
        const r = await fetch(DON.reception, {
          method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: corps, signal: arret.signal, redirect: "follow"
        });
        clearTimeout(minuteur);
        rep = await r.json();
      } catch (e) { rep = null; }
    }
    return rep;
  }

  $("#am-envoyer").addEventListener("click", async () => {
    if (envoiEnCours) return;
    let ok = true;
    const verifier = (cle, condition) => {
      const c = $("#am-c-" + cle);
      c.classList.toggle("erreur", !condition);
      if (!condition && ok) $("#am-" + cle).focus();
      ok = ok && condition;
    };
    verifier("societe", !!v("#am-societe"));
    verifier("nom", !!v("#am-nom"));
    verifier("email", /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v("#am-email")));
    verifier("projet", v("#am-projet").length >= 10);
    if (!ok) return;

    if (!DON.reception) { montrerErreur("L'envoi en ligne n'est pas ouvert pour le moment.", true); return; }

    envoiEnCours = true;
    const b = $("#am-envoyer"); b.disabled = true; b.textContent = "Envoi…";
    cacherErreur();

    const joints = [];
    for (const f of fichiers) {
      try { joints.push({ role: "documents", nom: f.name, type: f.type, base64: await enBase64(f) }); } catch (e) {}
    }
    const r = {
      lieu: v("#am-lieu"), surface: v("#am-surface"), interieur: v("#am-interieur"),
      budgetAmenagement: v("#am-budget"), echeance: v("#am-echeance")
    };
    const corps = JSON.stringify({
      id: identifiant || (identifiant = nouvelId()),
      duree: Math.round((Date.now() - DEBUT) / 1000),
      siteWeb: v("#am-site-web"),
      type: "amenagement",
      contact: { societe: v("#am-societe"), nom: v("#am-nom"), email: v("#am-email"), telephone: v("#am-telephone") },
      reponses: r,
      resume: [
        ["Type de demande", "Aménagement d'espace"],
        ["Projet", v("#am-projet")],
        ["Type de lieu", r.lieu || "Non précisé"],
        ["Surface ou nombre d'espaces", r.surface || "Non précisée"],
        ["Intérieur ou extérieur", r.interieur || "Non précisé"],
        ["Budget indicatif", r.budgetAmenagement || "À définir ensemble"],
        ["Échéance", r.echeance || "Non précisée"],
        ["Contact", [v("#am-societe"), v("#am-nom"), v("#am-email"), v("#am-telephone")].filter(Boolean).join("\n")]
      ],
      fichiers: joints
    });

    const rep = await poster(corps);
    envoiEnCours = false; b.disabled = false; b.textContent = "Envoyer mon projet";
    if (rep && rep.ok) { $("#am-form").hidden = true; $("#am-merci").hidden = false; $("#am-merci").scrollIntoView({ block: "center", behavior: "smooth" }); return; }
    if (rep && rep.erreur === "limite") { montrerErreur("Vous nous avez déjà écrit plusieurs fois dans l'heure. Pour ajouter un message :", true); return; }
    montrerErreur("L'envoi n'a pas abouti, votre texte est conservé. Réessayez dans un instant, ou :", true);
  });
})();
